module.exports = __webpack_public_path__ + "img/djj.a7ec604f.png";